// import { createEntityAdapter, createSelector } from '@reduxjs/toolkit'
import { createApi } from '@reduxjs/toolkit/query/react'

import obj2Fd from 'Utils/object-to-fd'
import { rtkBaseQuery } from '../../api'

// const botProfilesAdapter = createEntityAdapter({
//   // identify profiles with id
//   selectId: (profile) => profile.id
//   // Keep the "all IDs" array sorted based on book name
//   // sortComparer: (a, b) => a.name.localeCompare(b.name),
// })

// const initialState = botProfilesAdapter.getInitialState()

export const botProfilesApi = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: 'botProfilesApi',
  tagTypes: ['BotProfile'],
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    getAllBotProfiles: builder.query({
      query: () => '/v1/bot-profiles/'
      // transformResponse: (responseData) => {
      //   return botProfilesAdapter.setAll(initialState, responseData)
      // }
    }),
    getBotProfile: builder.query({
      query: (id) => `/v1/bot-profiles/${id}`,
      providesTags: ['BotProfile']
    }),
    updateBotProfile: builder.mutation({
      query: (data) => {
        const { id, ...payload } = data

        return {
          url: `/v1/bot-profiles/${id}`,
          method: 'PATCH',
          body: payload
        }
      },
      invalidatesTags: ['BotProfile']
    }),
    updateTranscriptEmail: builder.mutation({
      query: (data) => {
        const { id, ...payload } = data

        return {
          url: `/v1/bot-profiles/${id}/transcript-email`,
          method: 'POST',
          body: payload
        }
      },
      invalidatesTags: ['BotProfile']
    }),
    resendTranscriptVerificationEmail: builder.mutation({
      query: (id) => {
        return {
          url: `/v1/bot-profiles/${id}/transcript-email/resend`,
          method: 'POST'
        }
      },
      invalidatesTags: ['BotProfile']
    }),
    updateBotAppearance: builder.mutation({
      query: (data) => {
        const { id, ...payload } = data

        const body = payload.iconFile ? obj2Fd(payload) : payload

        return {
          url: `/v1/bot-profiles/${id}/settings/appearance`,
          method: 'PATCH',
          body
        }
      },
      invalidatesTags: ['BotProfile']
    })
  })
})

export default botProfilesApi

export const {
  useGetAllBotProfilesQuery,
  useGetBotProfileQuery,
  useUpdateBotProfileMutation,
  useUpdateTranscriptEmailMutation,
  useResendTranscriptVerificationEmailMutation,
  useUpdateBotAppearanceMutation
} = botProfilesApi

export const selectUsersResult = botProfilesApi.endpoints.getAllBotProfiles.select()

// const selectBotProfilesData = createSelector(selectUsersResult, (botProfiles) => botProfiles.data)

// const selectors = botProfilesAdapter.getSelectors((state) => selectBotProfilesData(state) ?? initialState)
// export const { selectAll: selectAllBotProfiles, selectById: selectBotProfileById } = selectors
